import clsx from 'clsx';
import React from 'react';

import styles from './ProgressLoader.module.scss';

interface LoaderProps {
  className?: string;
}

export const ProgressLoader: React.FC<LoaderProps> = ({ className }) => (
  <div className={clsx(styles.wrapper, className)}>
    <span className={styles.loader} />
  </div>
);
